export const normalizeFormatA = (phone: string): string => {
  // xxx xx xx xx
  // normalize string and remove all unnecessary characters
  phone = phone.replace(/[^\d]/g, "");

  // check if number length equals to 10

  if (phone.length > 9) {
    // reformat and return phone number
    return phone;
  } else if (phone.length > 7) {
    // reformat and return phone number
    return phone.replace(/(\d{3})(\d{2})(\d{2})(\d*)/, "$1 $2 $3 $4");


  // check if number length equals to 10
  } else if (phone.length > 5) {
    // reformat and return phone number
    return phone.replace(/(\d{3})(\d{2})(\d*)/, "$1 $2 $3");


  // check if number length equals to 10
  } else if (phone.length > 3) {
    // reformat and return phone number
    return phone.replace(/(\d{3})(\d*)/, "$1 $2");
  }

  return phone;
};

export const normalizeFormatB = (phone: string): string => {
  // xxx xxx xxx
  // normalize string and remove all unnecessary characters
  phone = phone.replace(/[^\d]/g, "");

  // check if number length equals to 10

  if (phone.length > 9) {
    // reformat and return phone number
    return phone;


  // check if number length equals to 10
  } else if (phone.length > 6) {
    // reformat and return phone number
    return phone.replace(/(\d{3})(\d{3})(\d*)/, "$1 $2 $3");


  // check if number length equals to 10
  } else if (phone.length > 3) {
    // reformat and return phone number
    return phone.replace(/(\d{3})(\d*)/, "$1 $2");
  }

  return phone;
};

